"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.user = void 0;

var corona_1 = require("corona");

var user_1 = require("../types/user");

function user(state, action) {
  if (state === void 0) {
    state = corona_1.EmptyUser();
  }

  switch (action.type) {
    case user_1.SET_USER:
      return action.user;

    default:
      return state;
  }
}

exports.user = user;